import { graphql } from 'react-apollo'
import { Layout, Form, Button, Input, notification, Divider, Table } from 'antd'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import searchItemsQuery from '../graphql/queries/searchItems'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class SearchItems extends Component {
  state = {
    submitting: false,
    items: [],
  }
  loadItems = async () => {
    this.setState({ submitting: true })
    const id = this.props.form.getFieldValue('id')
    try {
      if (id) {
        const { data: { items } } = await this.props.items.refetch({ _id: id })
        console.log(items)
        this.setState({ items })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Product',
        key: 'group',
        render: record => `${record.product.name} ${record.product.size} ${record.product.color}`,
      },
      {
        title: 'Item ID',
        key: 'itemId',
        width: 150,
        render: record => record.itemId,
      },
      {
        title: 'Check-in',
        key: 'checkin',
        render: record => (<span>{record.checkInBy.name}<br />{moment(record.checkInAt).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:SS')}</span>),
      },
      {
        title: 'Check-out',
        key: 'checkout',
        render: record => (record.checkOutAt ? (<span>{record.checkOutBy.name}<br />{moment(record.checkOutAt).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:SS')}</span>) : '-'),
      },
    ]
    return (
      <Layout>
        <Navbar selected="search:4" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="Item id"
              >
                {getFieldDecorator('id', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input id!' }],
                })(
                  <Input type="text" name="id" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadItems} disabled={this.state.submitting}>Search</Button>
              </FormItem>
            </Form>
            <Divider />
            {this.state.items.length > 0 ? (
              <div>
                <h2>Items</h2>
                <Table
                  rowKey="_id"
                  dataSource={this.state.items}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
SearchItems.propTypes = {
  form: PropTypes.shape(),
}
SearchItems.defaultProps = {
  form: {},
}

export default graphql(searchItemsQuery, { name: 'items', options: { variables: { _id: '' } } })(Form.create()(SearchItems))



// WEBPACK FOOTER //
// ./src/pages/SearchItems.js